<template>
    <nav class="navbar" v-bind:class="{'navbar--home' : $route.path == '/'}">
        <div class="container">
            <button v-if="smallScreens" 
                    class="navbar__burger"
                    v-bind:class="{'navbar__burger--active' : isMenuOpen}" 
                    @click="toggleMenu">
                    <span class="navbar__burger-line navbar__burger-line--first">&nbsp;</span>
                    <span class="navbar__burger-line navbar__burger-line--second">&nbsp;</span>
                {{(!isMenuOpen) ? 'Menu' : 'Fechar'}}
            </button>
            <transition name="fade">
                <div v-if="main" class="navbar__image-container">
                    <router-link class="navbar__img-link" to='/'>
                        <img class="navbar__image" src="../assets/sousa-branco.svg" alt="assinatura">
                    </router-link>
                </div>
            </transition>
            <div class="navbar__navigation-container" v-bind:class="{'navbar__navigation-container--open' : isMenuOpen}">
                <ul class="navbar__navigation">
                    <li v-for="(route, key) in routes" :key='key' class="navbar__item">
                        <router-link :to="route.path" 
                                    class="navbar__link" 
                                    exact-active-class="navbar__link--active"
                                    @click.native="toggleMenu"
                                    > 
                                        {{ route.name  | capitalize}} 
                        </router-link>
                    </li>
                </ul>
                <p v-if="screenType === 'phone'" class="navbar__copyright">&copy; feito por Italo Fontes | {{year}}</p>
            </div>

        </div>
     </nav>   
        
    
</template>
<script>
import { respondMixin, dateMixin } from "../misc/mixins";

export default {
  name: "HeaderComp",
  mixins: [respondMixin, dateMixin],
  data: function() {
    return {
      isMenuOpen: false,
    };
  },
  computed: {
    routes: function() {
      const routes = this.$router.options.routes.map((route) => {
        return { name: route.name, path: route.path };
      });

      return routes;
    },
    main: function() {
      return !(this.$route.path === "/") ? true : false;
    },
    smallScreens: function() {
      if (this.screenType === "phone" || this.screenType === "tab-port")
        return true;
      else return false;
    },
  },
  methods: {
    toggleMenu: function() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>
<style lang="scss">
.navbar {
  background-color: $color-cream;
  padding: 2rem 0;
  width: 100%;
  transition: all 1s;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  @include clearfix;

  @include respond(tab-port) {
    padding: 3rem 3rem;
    height: 12rem;
  }

  &--home {
    background-color: transparent;

    .navbar__link {
      color: $color-cream;
    }
    .navbar__link::after,
    .navbar__link::before,
    .navbar__link:hover::before {
      background: $color-cream;
    }
  }

  &__image-container {
    width: 10rem;
    float: left;
  }

  &__img-link {
    display: block;
  }

  &__image {
    width: 100%;
    transform: rotate(4deg);
  }

  &__burger {
    color: $color-wine;
    position: fixed;
    top: 3rem;
    right: 3rem;
    font-family: inherit;
    border: none;
    outline: none;
    font-size: 1.4rem;
    background-color: transparent;
    cursor: pointer;
    z-index: 2000;
    padding-top: 3rem;
    transition: all 0.8s;
    width: 5rem;

    &-line {
      width: 3rem;
      height: 1px;
      display: block;
      position: absolute;
      background: $color-wine;
      transition: all 0.3s cubic-bezier(0.4, 0.01, 0.165, 0.99);
      transition-delay: 0s;
      left: 50%;

      &--first {
        transform: translate(-50%, 0) rotate(0deg);
        top: 1rem;
      }

      &--second {
        transform: translate(-50%, 0.6rem) rotate(0deg);
        top: 1.1rem;
      }
    }

    &--active {
      color: $color-cream;

      & .navbar__burger-line {
        background: $color-cream;
        transition: all 0.4s cubic-bezier(0.4, 0.01, 0.165, 0.99);
        transition-delay: 0.2s;

        &--first {
          transform: translate(-50%, 0.4rem) rotate(45deg);
        }

        &--second {
          transform: translate(-50%, 0.3rem) rotate(-45deg);
        }
      }
    }
  }

  &__navigation-container {
    float: right;

    @include respond(tab-port) {
      position: fixed;
      height: 100vh;
      width: 100%;
      top: -100vh;
      left: -100%;
      will-change: transform;
      transition: all 0.8s;
      background-color: $color-wine;
      z-index: 1000;

      &--open {
        transform: translate(100%, 100vh);
      }
    }
  }

  &__navigation {
    @include clearfix;

    @include respond(tab-port) {
      text-align: center;
      margin-top: 25vh;
    }
  }

  &__item {
    float: left;

    &:not(:last-of-type) {
      margin-right: 4rem;
    }

    @include respond(tab-port) {
      float: none;

      &:not(:last-of-type) {
        margin-right: initial;
      }
    }
  }

  &__link {
    display: block;
    padding: 2.4rem 0.3rem;
    position: relative;
    cursor: pointer;

    @include respond(tab-port) {
      color: $color-cream;
    }
    /*&--active{
            border-bottom:.2rem solid $color-wine;
        }*/

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0%;
      height: 2px;
      bottom: 1.6rem;
      background: $color-wine-lighten;

      @include respond(tab-port) {
        display: none;
      }
    }

    &:before {
      left: 0;
    }
    &:after {
      right: 0;
      background: $color-wine-lighten;
      transition: width 0.8s cubic-bezier(0.22, 0.61, 0.36, 1);
    }

    &:hover:before {
      background: $color-wine-lighten;
      width: 100%;
      transition: width 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
    }

    &:hover:after {
      background: transparent;
      width: 100%;
      transition: 0s;
    }

    &--active::after {
      width: 100%;
    }
  }

  &__copyright {
    width: 100%;
    text-align: center;
    color: $color-wine-light;
    font-size: 1.3rem;
    display: block;
    position: absolute;
    bottom: 8rem;
  }
}
</style>
